/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_IntroInputs */

const tr_servis_s5_intro = /** @type {(inputs: Servis_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket, aşağıdaki hallerde hesabı askıya alabilir:`)
};

const en_servis_s5_intro = /** @type {(inputs: Servis_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company may suspend the account in the following cases:`)
};

const de_servis_s5_intro = /** @type {(inputs: Servis_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen kann das Konto in den folgenden Fällen sperren:`)
};

const ru_servis_s5_intro = /** @type {(inputs: Servis_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания может приостановить учетную запись в следующих случаях:`)
};

/**
* | output |
* | --- |
* | "The Company may suspend the account in the following cases:" |
*
* @param {Servis_S5_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_intro = /** @type {((inputs?: Servis_S5_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_intro(inputs)
	if (locale === "de") return de_servis_s5_intro(inputs)
	if (locale === "ru") return ru_servis_s5_intro(inputs)
	return tr_servis_s5_intro(inputs)
});